"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ITitleEscrowSignable__factory = void 0;

var _ethers = require("ethers");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const _abi = [{
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "fromBeneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "toBeneficiary",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "BeneficiaryTransfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "hash",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "endorser",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "CancelBeneficiaryTransferEndorsement",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "fromHolder",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "toHolder",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "HolderTransfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "prevNominee",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "nominee",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Nomination",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Shred",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "surrenderer",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Surrender",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "beneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "holder",
    type: "address"
  }, {
    indexed: true,
    internalType: "bool",
    name: "isMinting",
    type: "bool"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "TokenReceived",
  type: "event"
}, {
  inputs: [],
  name: "active",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "beneficiary",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    components: [{
      internalType: "address",
      name: "beneficiary",
      type: "address"
    }, {
      internalType: "address",
      name: "holder",
      type: "address"
    }, {
      internalType: "address",
      name: "nominee",
      type: "address"
    }, {
      internalType: "address",
      name: "registry",
      type: "address"
    }, {
      internalType: "uint256",
      name: "tokenId",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "nonce",
      type: "uint256"
    }],
    internalType: "struct BeneficiaryTransferEndorsement",
    name: "endorsement",
    type: "tuple"
  }],
  name: "cancelBeneficiaryTransfer",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "holder",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "isHoldingToken",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "nominee",
    type: "address"
  }],
  name: "nominate",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "nominee",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "operator",
    type: "address"
  }, {
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "onERC721Received",
  outputs: [{
    internalType: "bytes4",
    name: "",
    type: "bytes4"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "registry",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "shred",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "surrender",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "tokenId",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "nominee",
    type: "address"
  }],
  name: "transferBeneficiary",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    components: [{
      internalType: "address",
      name: "beneficiary",
      type: "address"
    }, {
      internalType: "address",
      name: "holder",
      type: "address"
    }, {
      internalType: "address",
      name: "nominee",
      type: "address"
    }, {
      internalType: "address",
      name: "registry",
      type: "address"
    }, {
      internalType: "uint256",
      name: "tokenId",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "nonce",
      type: "uint256"
    }],
    internalType: "struct BeneficiaryTransferEndorsement",
    name: "endorsement",
    type: "tuple"
  }, {
    components: [{
      internalType: "bytes32",
      name: "r",
      type: "bytes32"
    }, {
      internalType: "bytes32",
      name: "s",
      type: "bytes32"
    }, {
      internalType: "uint8",
      name: "v",
      type: "uint8"
    }],
    internalType: "struct SigHelper.Sig",
    name: "sig",
    type: "tuple"
  }],
  name: "transferBeneficiaryWithSig",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newHolder",
    type: "address"
  }],
  name: "transferHolder",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "nominee",
    type: "address"
  }, {
    internalType: "address",
    name: "newHolder",
    type: "address"
  }],
  name: "transferOwners",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];

class ITitleEscrowSignable__factory {
  static createInterface() {
    return new _ethers.utils.Interface(_abi);
  }

  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }

}

exports.ITitleEscrowSignable__factory = ITitleEscrowSignable__factory;

_defineProperty(ITitleEscrowSignable__factory, "abi", _abi);